<app-header></app-header>
<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.25)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple">
</ngx-spinner>
<div class="container">
  <router-outlet></router-outlet>
</div>

